import styled, { css } from "styled-components";
import { IFrameStyleProps, IContainerStyleProps } from "./interfaces";

export const StyledFrame = styled.div<IFrameStyleProps>`
    align-items: center;
    display: flex;
    justify-content: center;
    background: ${p => (p.transparent ? "transparent" : p.theme.c.white)};
    ${p =>
        p.backgroundColor &&
        css`
            background-color: ${p.backgroundColor};
        `}
`;

export const Container = styled.div<IContainerStyleProps>`
    box-shadow: 0 0 6px 0 ${p => p.theme.c.blackShadow4};
    transform-origin: left top;
    box-sizing: border-box;
    ${p => !p.isFlowExperience && css`
        overflow: hidden;
    `}
`;
